import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SERVER_API_URL} from 'app/app.constants';

@Injectable({
    providedIn: 'root'
})
export class SuggestionService {
    constructor(private http: HttpClient) {}

    getSuggestion = (file: any, entity: any, type: any): Promise<any> => {
        return this.http.post<any>(SERVER_API_URL + `api/ai/file/${entity}/${type}`, file).toPromise();
    };

    getSuggestionText = (text: any, entity: any): Promise<any> => {
        return this.http.post<any>(SERVER_API_URL + `api/ai/text/${entity}`, text).toPromise();
    };

    getCommand = (file: any, commands: any): Promise<any> => {
        return this.http.post<any>(SERVER_API_URL + `api/ai/command/file/${commands}`, file).toPromise();
    };

    getCommandText = (text: any, commands: any): Promise<any> => {
        return this.http.post<any>(SERVER_API_URL + `api/ai/command/text/${commands}`, text).toPromise();
    };

    getDbData = (prompt): Promise<any> => {
        return this.http.get<any>(SERVER_API_URL + `api/ai/sql/${prompt}`).toPromise();
    };

    aiText = (prompt, data_format): Promise<any> => {
        return this.http
            .post<any>(SERVER_API_URL + `api/ai`, {
                text: prompt,
                format: data_format
            })
            .toPromise();
    };

    aiUI = (prompt, data_format): Promise<any> => {
        return this.http
            .post<any>(SERVER_API_URL + `api/ai/ui`, {
                text: prompt,
                format: data_format
            })
            .toPromise();
    };

    aiFile = (file, type, data_format): Promise<any> => {
        return this.http
            .post<any>(SERVER_API_URL + `api/ai`, {
                format: data_format,
                file: file,
                type: type
            })
            .toPromise();
    };

    sendEmail = (file: Blob, fileName: string): Promise<any> => {
        const formData = new FormData();
        formData.append('file', new Blob([file]), fileName);

        return this.http.post<any>(`${SERVER_API_URL}api/ai/email-file`, formData).toPromise();
    };

    getPrompts = (): Promise<any> => {
        return this.http.get<any>(SERVER_API_URL + `api/prompts`).toPromise();
    };

    deletePrompt = (promptId): Promise<any> => {
        return this.http.delete<any>(SERVER_API_URL + `api/prompts/${promptId}`).toPromise();
    };
}
